import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { SyntheticEvent, useState } from 'react'
import { InferenceData } from 'type/inference'
import css from './Image.module.scss'

type Props = {
  inference: InferenceData
  onGood?: (good: boolean) => void
  onSize?: (width: number, height: number) => void
  preview?: boolean
}

export const Image = observer(({ inference, onGood, onSize, preview }: Props) => {
  const source = inference.image
  const [good, setGood] = useState(false)
  const className = clsx(css.image, good && css.good, preview && css.preview)

  const onLoad = useLatestCallback((event: SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth, naturalHeight } = event.currentTarget
    setGood(true)
    onGood?.(true)
    onSize?.(naturalWidth, naturalHeight)
  })

  const onError = useLatestCallback(() => {
    setGood(false)
    onGood?.(false)
  })

  return <img className={className} src={source} onLoad={onLoad} onError={onError} />
})
